import { api } from "@/lib/api";

export const settingsApi = {
  meta: () => api.get("/settings/meta").then((r) => r.data),
  getCompany: () => api.get("/settings/company").then((r) => r.data),
  updateCompany: (data) => api.put("/settings/company", { data }).then((r) => r.data),
  getPreferences: () => api.get("/settings/preferences").then((r) => r.data),
  updatePreferences: (data) => api.put("/settings/preferences", { data }).then((r) => r.data),
  numberSeries: () => api.get("/settings/number-series").then((r) => r.data),
  listMasters: (type) => api.get(`/settings/masters/${type}`).then((r) => r.data),
  createMaster: (type, body) => api.post(`/settings/masters/${type}`, body).then((r) => r.data),
  updateMaster: (id, body) => api.put(`/settings/masters/${id}`, body).then((r) => r.data),
  deleteMaster: (id) => api.delete(`/settings/masters/${id}`).then((r) => r.data),
};
